import { useState, useRef, useEffect } from 'react';
import ListComponent from '@/pcomponents/common/crud/list/list/list_component';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import { useSelector, useDispatch } from 'react-redux';
import ShopFunc from "@/pcomponents/common/content/shop/order/func/shop_func";
import getXcolumnJson from "./xcolumn/list";
import TopTabArea from "@/pages/comp/book_order/shop/order/acommon/list/area/top_tab";
import SearchArea from "@/pages/comp/book_order/shop/order/acommon/list/area/search";
import SumMoneyArea from "@/pages/comp/book_order/shop/order/acommon/list/area/sum_money";
import OrderDetailRowArea from "@/pages/comp/book_order/shop/order/acommon/list/area/detail_row";

function OrderListCompArea(props: any) {
  let myProps = {
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const xColumnArr = getXcolumnJson();
  const ListComponentRef = useRef<any>(null);
  const listOptRef = useRef<any>({});
  const [is_show_detail, set_is_show_detail] = useState(true);
  const OrderListExcelDownRef = useRef<any>(null);

  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    select_seq: "",
    s_mcomp_seq: "",
    s_state: "request",
    s_date_type: "a_date",
    s_start_date: DateFunc.get_date_format(new Date(), "Y-m-01"),
    s_end_date: DateFunc.get_date_format(new Date(), "Y-m-t"),
    s_in_out: "out",
    s_title_like: "",
    s_user_name_like: "",
    s_mcomp_name_like: "",
    s_mcomp_group_seq: "",
    s_mcomp_sort_detail: "",
    order_id: "a_date DESC, a_seq DESC",
    s_money_sum: "1",
    s_addon_mcomp: "1",
    s_addon_detail: "1",
    s_addon_payt: "1",
  });
  listOptRef.current = listOpt;
  const [infoArr, setInfoArr] = useState([]);
  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  let select_order_state_arr = ShopFunc.select_order_state_arr;
  let select_in_out_arr = ShopFunc.select_in_out_arr;
  let select_pay_sort = ShopFunc.select_pay_sort;

  useEffect(() => {
    list({});
  }, [user]);

  const list = (inOptObj: any) => {
    let tmp_list_opt = {
      ...listOpt,
      is_excel_down: false,
      ...inOptObj
    };
    setListOpt(tmp_list_opt);
    if (tmp_list_opt.is_excel_down) {
      tmp_list_opt.is_paging = "";
    } else {
      tmp_list_opt.is_paging = "1";
    }

    if (strFunc.is_empty(user.comp_seq)) {
      return false;
    }
    tmp_list_opt.s_mcomp_seq = user.comp_seq;

    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_order/list',
      tmp_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (tmp_list_opt.is_excel_down) {
            if (OrderListExcelDownRef.current) {
              OrderListExcelDownRef.current.goExcelDown({
                infoArr: response.data["data"]["info_arr"]
              });
            }
            return false;
          }
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          if (ListComponentRef.current) {
            ListComponentRef.current.setInfoArr(response.data["data"]["info_arr"]);
            setSelectbySelectedSeq({
              select_seq: tmp_list_opt.select_seq,
              info_arr: response.data["data"]["info_arr"],
            });
          }
        } else {

        }
      });
  };

  const setSelectbySelectedSeq = (inData: any) => {
    let opt_obj = {
      select_seq: "",
      info_arr: infoArr,
      ...inData
    };
    if (opt_obj.select_seq != "") {
      setTimeout(() => {
        if (ListComponentRef.current) {
          let active_row_arr: any = [];
          for (let i = 0; i < opt_obj.info_arr.length; i++) {
            let info = opt_obj.info_arr[i];
            if (info.row_pri_val == opt_obj.select_seq) {
              active_row_arr.push(true);
            } else {
              active_row_arr.push(false);
            }
          }
          ListComponentRef.current.set_active_row_arr(active_row_arr);
        }
      }, 100);
    }
  };

  const rowOnClick = (rowData: any, idx: number, e: any, key: string) => {

  };

  const customCellRenderer = (params: any) => {
    /*
    {
      "rowData":rowData,
      "idx":idx,
      "key":key,
      "value":row_val,
      "origin_val":origin_val,
    }
    */
    if (params.key === "row_view_amount") {
      if (params.rowData.order_det_amount) {
        params.value = strFunc.comma(params.rowData.order_det_amount);
      }
    } else if (params.key === "row_view_price") {
      if (params.rowData.order_det_price) {
        params.value = strFunc.comma(params.rowData.order_det_price);
      }
    } else if (params.key === "row_view_in_out") {
      let find_obj = select_in_out_arr.find((el: any) => el.value == params.rowData.a_in_out);
      if (find_obj) {
        params.value = find_obj.text;
      }
    } else if (params.key === "row_view_state") {
      let find_obj = select_order_state_arr.find((el: any) => el.value == params.rowData.a_state);
      if (find_obj) {
        params.value = find_obj.text;
      }
    } else if (params.key === "row_view_payt_sort") {
      let pay_sort_str = "";
      for (let i = 0; i < select_pay_sort.length; i++) {
        if (select_pay_sort[i].value == params.rowData.a_pay_sort) {
          pay_sort_str = select_pay_sort[i].text;
        }
      }
      params.value = (
        <div>
          {pay_sort_str}
        </div>
      );
    } else if (params.key === "row_view_req_comp_name") {
      if (params.rowData.mcomp_name) {
        params.value = params.rowData.mcomp_name;
      }
    } else if (params.key == "row_view_detail_title") {
      params.value = (
        <OrderDetailRowArea
          row_data={params.rowData}
          is_show_detail={is_show_detail}
        ></OrderDetailRowArea>
      );
    }

    return params.value;
  };

  return (
    <div>
      <div style={{ minWidth: "500px" }}>
        <div>
          <TopTabArea
            listOpt={listOpt}
            setListOpt={setListOpt}
            list={list}
          ></TopTabArea>
        </div>
        <div className='mt-2'>
          <SearchArea
            listOpt={listOpt}
            setListOpt={setListOpt}
            list={list}
            is_show_detail={is_show_detail}
            set_is_show_detail={set_is_show_detail}
            is_show_del_btn={false}
            is_show_comp_search={false}
          ></SearchArea>
        </div>
        <div className='mt-1'>
          <SumMoneyArea
            countInfo={countInfo}
          ></SumMoneyArea>
        </div>
        <div className="mt-1">
          <ListComponent
            ref={ListComponentRef}
            xColumnArr={{ ...xColumnArr }}
            gridOpt={{
              fix_left_num: xColumnArr.list_opt_arr.fix_left_num,
              is_add_idx_num: false,
              is_add_checkbox: true,
              td_align: "center",
              height: "auto",
              is_fix_width: true,
              rowMultiSelectWithClick: false,
              onGridReady: () => {

              },

              is_all_select_row_key: true,
              rowOnClick: rowOnClick,
              customCellRenderer: customCellRenderer,
              class_name_json: {
                table_div: "basic_list_div",
                td_div: "row-col-div",
                input_check: "chk_row",
                row_input: "row-input",
                data_row_tr: "data_row_tr",
                active_row: "active",
                empty_con_div: "list_empty_content_div",
              },
            }}
          ></ListComponent>
        </div>
        <Paging now_page={listOpt.now_page}
          num_per_page={listOpt.num_per_page}
          total_rec={countInfo.tot}
          onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
          is_view_num_per_page={true}
          is_show_total_rec={true}
          onChangeNumPerPage={(num_per_page: number) => { list({ now_page: 1, num_per_page: num_per_page }); }}></Paging>
      </div>
    </div>
  );
}

export default OrderListCompArea;